var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    {
      staticClass: "table",
      class: { "table--stick-to-modal-sides": _vm.stickToSides }
    },
    [
      _c("thead", [
        _c("tr", { staticClass: "table__header-row" }, [
          _c("th", { staticClass: "table__header-cell" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("businessOrders.labels.sku")) +
                "\n            "
            )
          ]),
          _c("th", { staticClass: "table__header-cell" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("businessOrders.labels.description")) +
                "\n            "
            )
          ]),
          _vm.anyItemHasLotData && _vm.businessOrder.isLotTrackedOrder
            ? _c("th", { staticClass: "table__header-cell" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("businessOrders.labels.lotnumber")) +
                    "\n            "
                )
              ])
            : _vm._e(),
          _vm.anyItemHasLotData && _vm.businessOrder.isLotTrackedOrder
            ? _c("th", { staticClass: "table__header-cell" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("businessOrders.labels.expiration")) +
                    "\n            "
                )
              ])
            : _vm._e(),
          _c("th", { staticClass: "table__header-cell" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("businessOrders.labels.quantity")) +
                "\n            "
            )
          ])
        ])
      ]),
      _c(
        "tbody",
        _vm._l(_vm.packageItems, function(item) {
          return _c(
            "tr",
            {
              key: _vm.skuPrefix + "_" + item.sku,
              staticClass: "table__body-row"
            },
            [
              _c("td", { staticClass: "table__body-cell" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm._f("valueOrDash")(item.sku)) +
                    "\n            "
                )
              ]),
              _c("td", { staticClass: "table__body-cell" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm._f("valueOrDash")(item.description)) +
                    "\n            "
                )
              ]),
              _vm.anyItemHasLotData &&
              _vm.businessOrder.isLotTrackedOrder &&
              item.isLotTrackedItemExpired
                ? _c("td", { staticClass: "table__body-cell text-error" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("valueOrDash")(item.lotNumber)) +
                        "\n            "
                    )
                  ])
                : _vm.anyItemHasLotData && _vm.isLotTrackedOrder
                ? _c("td", { staticClass: "table__body-cell" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("valueOrDash")(item.lotNumber)) +
                        "\n            "
                    )
                  ])
                : _vm._e(),
              _vm.anyItemHasLotData &&
              _vm.businessOrder.isLotTrackedOrder &&
              item.isLotTrackedItemExpired
                ? _c("td", { staticClass: "table__body-cell text-error" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("valueOrDash")(
                            _vm._f("date")(item.expirationDate, "short")
                          )
                        ) +
                        "\n            "
                    )
                  ])
                : _vm.anyItemHasLotData && _vm.isLotTrackedOrder
                ? _c("td", { staticClass: "table__body-cell" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("valueOrDash")(
                            _vm._f("date")(item.expirationDate, "short")
                          )
                        ) +
                        "\n            "
                    )
                  ])
                : _vm._e(),
              _c("td", { staticClass: "table__body-cell" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm._f("valueOrDash")(item.quantity)) +
                    "\n            "
                )
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }